<template>
  <section class="h_71">
    <m-img class="bg_img" src="@/v2/mobile/assets/image/h_71_1.jpg"></m-img>
    <m-img class="bg_img" src="@/v2/mobile/assets/image/h_71_2.jpg"></m-img>
    <m-img class="bg_img" src="@/v2/mobile/assets/image/h_71_3.jpg"></m-img>
    <div class="map-content" v-ia>
      <div class="map-item border_container_light">
        <div class="map-item-title map-layers-container">
          <div class="map-layers-item">
            <img :src="ImgBase" alt="" />
          </div>
          <!-- 使用绝对定位叠加图层 -->
          <template v-for="(item, index) in controlArr">
            <img
              :key="index"
              v-if="isLayerActive(index + 1)"
              :src="item.image"
              :alt="item.title"
              class="map-layers-item"
            />
          </template>
        </div>
      </div>
      <div class="control-container">
        <div
          v-for="(item, index) in controlArr"
          :key="index"
          class="map71-control-item"
          :class="{ active: isLayerActive(index + 1) }"
          @click="switchImage(index + 1)"
        >
          <img
            :src="
              isLayerActive(index + 1) ? item.activeIcon : item.inactiveIcon
            "
            :alt="item.title"
          />
          <div
            class="control-container-name"
            :class="{ active: isLayerActive(index + 1) }"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ImgBase from '@/v2/auto/assets/image/71/2/base.jpg'
import Img2 from '@/v2/auto/assets/image/71/2/site.png'
import Img3 from '@/v2/auto/assets/image/71/2/event.png'
import Img4 from '@/v2/auto/assets/image/71/2/recomand.png'
import Img5 from '@/v2/auto/assets/image/71/2/road.png'
import activeIcon1 from '@/v2/auto/assets/image/71/2/active/1.svg'
import activeIcon2 from '@/v2/auto/assets/image/71/2/active/2.svg'
import activeIcon3 from '@/v2/auto/assets/image/71/2/active/3.svg'
import activeIcon4 from '@/v2/auto/assets/image/71/2/active/4.svg'
import inactiveIcon1 from '@/v2/auto/assets/image/71/2/inactive/1.svg'
import inactiveIcon2 from '@/v2/auto/assets/image/71/2/inactive/2.svg'
import inactiveIcon3 from '@/v2/auto/assets/image/71/2/inactive/3.svg'
import inactiveIcon4 from '@/v2/auto/assets/image/71/2/inactive/4.svg'
export default {
  data() {
    return {
      activeIndices: [1], // 改为数组，默认选中第一个
      ImgBase,
      controlArr: [
        {
          title: '路况',
          image: Img5,
          activeIcon: activeIcon1,
          inactiveIcon: inactiveIcon1,
        },
        {
          title: '地点',
          image: Img2,
          activeIcon: activeIcon2,
          inactiveIcon: inactiveIcon2,
        },
        {
          title: '事件',
          image: Img3,
          activeIcon: activeIcon3,
          inactiveIcon: inactiveIcon3,
        },
        {
          title: '推荐',
          image: Img4,
          activeIcon: activeIcon4,
          inactiveIcon: inactiveIcon4,
        },
      ],
    }
  },
  methods: {
    isLayerActive(index) {
      return this.activeIndices.includes(index)
    },
    switchImage(index) {
      const indexPosition = this.activeIndices.indexOf(index)
      if (indexPosition === -1) {
        // 如果不在选中列表中，添加
        this.activeIndices.push(index)
      } else {
        // 如果已经在选中列表中，移除
        this.activeIndices.splice(indexPosition, 1)
      }
      // 确保至少有一个图层是选中的
      if (this.activeIndices.length === 0) {
        this.activeIndices.push(1)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.h_71 {
  width: 100%;
  position: relative;
  .bg_img {
    margin-bottom: -2px;
  }
  .map-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 88%;
    position: absolute;
    top: 46%;
    margin: 0 6%;
  }

  .map-item {
    width: calc(100% - clamp(0.12rem, 6px, 0.2rem));
    max-width: 1200px;
    aspect-ratio: 1.6;
    overflow: hidden;
    img {
      width: 100%;
      // height: 100%;
      object-fit: contain;
      display: block;
    }
  }

  .map-layers-container {
    position: relative;
    width: 100%;
    height: 100%;
    .map-layers-item {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      // height: 100%;
      object-fit: contain;
      opacity: 1;
    }
  }

  .control-container {
    display: flex;
    gap: 24px;
    margin-top: 4px;
    justify-content: center;
    font-size: 14px;
    color: #666;
    transition: all 0.3s ease;
    margin-top: 32px;
    .control-container-name {
      margin-top: 8px;
      text-align: center;
    }
    &.active {
      color: #0061d8;
      font-weight: 500;
    }
  }

  .control-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }
}
</style>
